import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import frownIcon from '../../assets/images/frown-regular-blue.svg';
import './popupBlockerNotification.scss';

const popupBlockerNotification = ({ onClose }) => (
  <div className='popup-blocker-notification-wrapper'>
    <div className='popup-blocker-notification'>
      <div className='icon-wrapper'>
        <img alt='' className='inline-icon' src={frownIcon} />
      </div>
      <div className='middle-section'>
        <div className='title'>Notification</div>
        <div className='content'>
          Please disable Pop-up blocker in your browse settings to view PDFs.
          For iPhones, go to Settings, Safari and turn off switch for Block
          Pop-ups
        </div>
      </div>
      <div className='close-wrapper'>
        <IconButton aria-label='Close' onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </div>
    </div>
  </div>
);

export default popupBlockerNotification;
